<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M3 6.5c0-1.1.9-2 2-2h5.59l2 2H19c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-11zm2-1c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1h-6.83l-2-2H5z"
      />
    </svg>
  </span>
</template>
